@let nameControl = editForm.get('sectionName');
@let requiredError = nameControl?.invalid && (nameControl?.touched || nameControl?.dirty);

@let jsonPath = 'shop-settings.content.categories-editor';

<form
  [formGroup]="editForm"
  (ngSubmit)="onSubmit()"
  class="edit-categories"
  aria-label="categories-body"
>
  <div class="edit-categories__header">
    <label for="section-name" class="edit-categories__label">
      {{ jsonPath + '.section-name-label' | translate }}
    </label>
    <input
      id="section-name"
      class="edit-categories__input"
      type="text"
      [class.edit-categories__input--error]="requiredError"
      formControlName="sectionName"
    />

    @if (requiredError) {
      <div class="edit-categories__error-message">
        <span>{{ jsonPath + '.section-name-required' | translate }}</span>
      </div>
    }
  </div>
  <div class="edit-categories__search-section">
    <h2 class="edit-categories__title">{{ jsonPath + '.search-title' | translate }}</h2>
    <div class="edit-categories__header">
      <label for="category-search" class="edit-categories__label">
        {{ jsonPath + '.search-label' | translate }}
      </label>
      <div>
        <div class="edit-categories__search">
          <app-icon class="modal__cross-icon" [icon]="IconName.SEARCH" />
          <input
            #searchInput
            id="category-search"
            class="edit-categories__search-input"
            type="text"
            autocomplete="off"
            formControlName="search"
            placeholder="{{ jsonPath + '.search-input-placeholder' | translate }}"
            (focus)="onSearchFocus()"
            (blur)="onSearchBlur()"
          />
        </div>
        @if (searchFocused()) {
          <div class="edit-categories__datalist-wrapper">
            <ul class="edit-categories__datalist-list">
              @for (categoryOption of availableSearchOptions(); track categoryOption) {
                <li
                  class="edit-categories__datalist-item"
                  (mousedown)="selectCategory(categoryOption); $event.preventDefault()"
                >
                  {{ categoryOption.name }}
                </li>
              } @empty {
                <p class="edit-categories__datalist-empty" (mousedown)="$event.preventDefault()">
                  {{ jsonPath + '.datalist-empty' | translate }}
                </p>
              }
            </ul>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="edit-categories__display">
    <div class="edit-categories__row edit-categories__row--header">
      <div class="edit-categories__cell"></div>
      <div class="edit-categories__cell--name header--cell">
        {{ jsonPath + '.datalist-empty' | translate }}
      </div>
      <div class="edit-categories__cell"></div>
    </div>

    @for (category of proceedCategories(); track category) {
      <div class="edit-categories__row">
        <div class="edit-categories__cell">
          <app-icon class="modal__drag-indicator" [icon]="IconName.DRAG_INDICATOR" />
        </div>
        <div class="edit-categories__cell--name">{{ category.name }}</div>
        <div class="edit-categories__cell--end">
          <app-icon
            class="modal__bin-icon"
            (click)="removeCategory(category)"
            [icon]="IconName.TRASH_BIN_LIGHT"
          />
        </div>
      </div>
    }
  </div>
</form>
